import React from "react";
import styles from './status-cell.module.scss';

interface StatusCellRendererProps {
    status: string;
    description?: string;
    classes?: {
        container?: string;
        status?: string;
        description?: string;
    };
}

const statusClassMap: Record<string, string> = {
    "approved": "Approved",
    "rejected": "Rejected",
    "need approval": "NeedApproval",
    "project": "Project",
    "draft": "Draft",
    "under review": "UnderReview",
    "not initiated": "NotInitiated",
    "approved by mohup": "Approved",
    "rejected by mohup": "Rejected",
};

const StatusCell: React.FC<StatusCellRendererProps> = ({ status, description, classes = {} }) => {
    const normalizedStatus = status.trim().toLowerCase();
    const mappedClass = statusClassMap[normalizedStatus] || "";

    return (
        <div className={`${styles.cell} ${classes.container || ""}`}>
            {status  && (
                <span className={`${styles[mappedClass] || ""} ${classes.status || ""}`}>
                    {status}
                </span>
            )}
            {description && (
                <div className={`${classes.description || ""}`}>
                    {description}
                </div>
            )}
        </div>
    );
};

export default StatusCell;
